export const PROVIDERS = Object.freeze({
  google: "google.com",
  our: "password",
});
